export const CATEGORIES = {
  // --- FRUITS (100-109) ---
  APPLE: { icon: '/assets/apple_icon_128.webp', key: 'apple', sortOrder: 100 },
  BANANA: { icon: '/assets/bananen.webp', key: 'banana', sortOrder: 101 },
  CHERRY: { icon: 'lucide:cherry', key: 'cherry', sortOrder: 102 },
  GRAPE: { icon: '/assets/trauben.webp', key: 'grape', sortOrder: 103 },
  CITRUS: { icon: '/assets/zitrone.webp', key: 'citrus', sortOrder: 104 }, // lemon, orange, lime - defaulting to lemon image for generic citrus
  ORANGE: { icon: '/assets/orangen.webp', key: 'orange', sortOrder: 104 }, // NEW
  LEMON: { icon: '/assets/zitrone.webp', key: 'lemon', sortOrder: 104 }, // NEW
  MELON: { icon: 'mdi:fruit-watermelon', key: 'melon', sortOrder: 105 }, // watermelon
  PINEAPPLE: { icon: 'mdi:fruit-pineapple', key: 'pineapple', sortOrder: 106 },
  AVOCADO: { icon: '/assets/avocado.webp', key: 'avocado', sortOrder: 107 },
  STRAWBERRY: { icon: '/assets/erdbeeren.webp', key: 'strawberry', sortOrder: 108 },
  BERRIES: { icon: '/assets/beeren.webp', key: 'berry', sortOrder: 108 },
  PEAR: { icon: '/assets/birnen.webp', key: 'pear', sortOrder: 108 }, // NEW
  PEACH: { icon: '/assets/pfirsich.webp', key: 'peach', sortOrder: 108 }, // NEW
  MANGO: { icon: '/assets/mango.webp', key: 'mango', sortOrder: 108 }, // NEW
  FRUIT: { icon: '/assets/obst.webp', key: 'fruit', sortOrder: 109 }, // Generic fruit

  // --- VEGETABLES (110-140) ---
  CARROT: { icon: '/assets/karotten.webp', key: 'carrot', sortOrder: 110 },
  SALAD: { icon: '/assets/salat.webp', key: 'salad', sortOrder: 111 }, // Using specific salad icon
  TOMATO: { icon: 'mdi:tomato', key: 'tomato', sortOrder: 112 },
  PEPPER: { icon: '/assets/paprika.webp', key: 'pepper', sortOrder: 113 },
  ONION: { icon: '/assets/zwiebel.webp', key: 'onion', sortOrder: 114 },
  POTATO: { icon: '/assets/kartoffeln.webp', key: 'potato', sortOrder: 115 },
  MUSHROOM: { icon: '/assets/pilze.webp', key: 'mushroom', sortOrder: 116 },
  CORN: { icon: '/assets/mais.webp', key: 'corn', sortOrder: 117 },
  PEAS: { icon: '/assets/erbsen.webp', key: 'peas', sortOrder: 118 },
  SNOW_PEAS: { icon: '/assets/zuckerschoten.webp', key: 'snow_peas', sortOrder: 119 }, // NEW
  LEEK: { icon: '/assets/lauch.webp', key: 'leek', sortOrder: 120 }, // NEW
  BEETROOT: { icon: '/assets/rote_beete.webp', key: 'beetroot', sortOrder: 121 }, // NEW
  SAUERKRAUT: { icon: '/assets/sauerkraut.webp', key: 'sauerkraut', sortOrder: 122 }, // NEW
  CAULIFLOWER: { icon: '/assets/blumenkohl.webp', key: 'cauliflower', sortOrder: 123 }, // NEW
  BROCCOLI: { icon: '/assets/brokkoli.webp', key: 'broccoli', sortOrder: 124 }, // NEW
  CUCUMBER: { icon: '/assets/gurke.webp', key: 'cucumber', sortOrder: 125 }, // NEW
  PICKLES: { icon: '/assets/essiggurken.webp', key: 'pickles', sortOrder: 126 }, // NEW
  SPINACH: { icon: '/assets/spinat.webp', key: 'spinach', sortOrder: 127 }, // NEW
  ZUCCHINI: { icon: '/assets/zucchini.webp', key: 'zucchini', sortOrder: 128 }, // NEW
  SOUP_GREENS: { icon: '/assets/suppengemuese.webp', key: 'soup_greens', sortOrder: 129 }, // NEW
  VEGETABLE: { icon: 'lucide:carrot', key: 'veg', sortOrder: 130 }, // Generic veg
  SPROUTS: { icon: '/assets/sprossen.webp', key: 'sprouts', sortOrder: 131 }, // NEW
  CELERY: { icon: '/assets/stangensellerie.webp', key: 'celery', sortOrder: 132 }, // NEW
  PAK_CHOI: { icon: '/assets/pak_choi.webp', key: 'pak_choi', sortOrder: 133 },
  BASIL: { icon: '/assets/basilikum.webp', key: 'basil', sortOrder: 134 },
  CORIANDER: { icon: '/assets/koriander.webp', key: 'coriander', sortOrder: 135 },
  CABBAGE: { icon: '/assets/weisskohl.webp', key: 'cabbage', sortOrder: 136 },
  CHERRY_TOMATOES: { icon: '/assets/kirschtomaten.webp', key: 'cherry_tomatoes', sortOrder: 112 },
  PARSLEY: { icon: '/assets/petersilie.webp', key: 'parsley', sortOrder: 137 },
  FRESH_HERBS: { icon: '/assets/basilikum.webp', key: 'fresh_herbs', sortOrder: 138 },
  FRIED_ONIONS: { icon: '/assets/roestzwiebeln.webp', key: 'fried_onions', sortOrder: 139 },

  // --- BAKERY (200) ---
  BREAD: { icon: '/assets/brot.webp', key: 'bread', sortOrder: 200 }, // generic bread
  ROLLS: { icon: '/assets/broetchen.webp', key: 'rolls', sortOrder: 201 }, // NEW
  BAGUETTE: { icon: '/assets/baguette.webp', key: 'baguette', sortOrder: 201 },
  BURGER_BUN: { icon: '/assets/burgerbroetchen.webp', key: 'burger_bun', sortOrder: 202 }, // NEW
  CROISSANT: { icon: '/assets/crossiant.webp', key: 'croissant', sortOrder: 202 },
  SANDWICH: { icon: 'lucide:sandwich', key: 'sandwich', sortOrder: 203 },
  FLOUR: { icon: '/assets/mehl.webp', key: 'flour', sortOrder: 204 }, // Baking ingredients
  BAKING_POWDER: { icon: '/assets/backpulver.webp', key: 'baking_powder', sortOrder: 205 },
  FLAMMKUCHEN_BASE: { icon: '/assets/flammkuchenboden.webp', key: 'flammkuchen_base', sortOrder: 206 },

  // --- JAM/SPREADS (near bakery) ---
  JAM: { icon: '/assets/marmelade.webp', key: 'jam', sortOrder: 210 },
  HONEY: { icon: '/assets/honig.webp', key: 'honey', sortOrder: 211 }, // NEW

  // --- MEAT & FISH (300) ---
  MEAT: { icon: 'lucide:beef', key: 'meat', sortOrder: 300 },
  BBQ_MEAT: { icon: '/assets/grillgfleisch.webp', key: 'bbq_meat', sortOrder: 300 }, // NEW
  CHICKEN: { icon: 'lucide:drumstick', key: 'chicken', sortOrder: 301 },
  SAUSAGE: { icon: '/assets/wuestle.webp', key: 'sausage', sortOrder: 302 },
  BACON: { icon: '/assets/fruehstuecksspeck.webp', key: 'bacon', sortOrder: 303 },
  BACON_CUBES: { icon: '/assets/speckwuefel.webp', key: 'bacon_cubes', sortOrder: 304 },
  TOFU: { icon: '/assets/tofu.webp', key: 'tofu', sortOrder: 305 },
  MEATBALLS: { icon: '/assets/hackbaellchen.webp', key: 'meatballs', sortOrder: 306 },
  FISH: { icon: 'lucide:fish', key: 'fish', sortOrder: 310 },
  FISH_STICKS: { icon: '/assets/fischstaebchen.webp', key: 'fish_sticks', sortOrder: 310 },
  TUNA: { icon: '/assets/thunfisch.webp', key: 'tuna', sortOrder: 310 },
  SALMON: { icon: '/assets/lachs.webp', key: 'salmon', sortOrder: 310 },
  SEAFOOD: { icon: 'lucide:fish', key: 'seafood', sortOrder: 311 },

  // --- DAIRY & EGGS (400) ---
  MILK: { icon: '/assets/milch.webp', key: 'milk', sortOrder: 400 },
  BUTTER: { icon: '/assets/butter.webp', key: 'butter', sortOrder: 401 },
  YOGURT: { icon: '/assets/joghurt.webp', key: 'yogurt', sortOrder: 402 },
  CHEESE: { icon: '/assets/käse.webp', key: 'cheese', sortOrder: 403 },
  EGG: { icon: '/assets/eier_6.webp', key: 'egg', sortOrder: 404 },
  OATMILK: { icon: '/assets/hafermilch.webp', key: 'oatmilk', sortOrder: 405 }, // NEW
  CREAM: { icon: '/assets/sahne.webp', key: 'cream', sortOrder: 406 }, // NEW
  SOUR_CREAM: { icon: '/assets/creme_fraiche.webp', key: 'sour_cream', sortOrder: 407 }, // NEW
  DAIRY: { icon: 'lucide:milk', key: 'dairy', sortOrder: 409 }, // Generic

  // --- PANTRY (500) ---
  SPICE: { icon: 'mdi:shaker-outline', key: 'spice', sortOrder: 500 },
  BROTH: { icon: '/assets/gemuesebruehe.webp', key: 'broth', sortOrder: 500 }, // NEW
  OIL: { icon: '/assets/oel.webp', key: 'oil', sortOrder: 501 },
  SAUCE: { icon: 'mdi:bottle-soda-classic-outline', key: 'sauce', sortOrder: 502 },
  MUSTARD: { icon: '/assets/senf.webp', key: 'mustard', sortOrder: 502 },
  SOY_SAUCE: { icon: '/assets/sojasauce.webp', key: 'soy_sauce', sortOrder: 502 },
  MAYO: { icon: '/assets/majonaise.webp', key: 'mayo', sortOrder: 502 },
  KETCHUP: { icon: '/assets/ketchup.webp', key: 'ketchup', sortOrder: 502 },
  VINEGAR: { icon: '/assets/weisswein.webp', key: 'vinegar', sortOrder: 502 }, // NEW (using white wine icon as requested)
  DIP: { icon: 'mdi:bowl-mix-outline', key: 'dip', sortOrder: 503 },
  HUMMUS: { icon: '/assets/hummus.webp', key: 'hummus', sortOrder: 503 }, // NEW
  CANNED: { icon: 'mdi:canned-food', key: 'canned', sortOrder: 504 },
  CANNED_TOMATOES: { icon: '/assets/dosentomaten.webp', key: 'canned_tomatoes', sortOrder: 504 },
  TOMATO_PASTE: { icon: '/assets/tomatenmark.webp', key: 'tomato_paste', sortOrder: 504 },
  PASTA: { icon: '/assets/nudeln.webp', key: 'pasta', sortOrder: 505 },
  SPAGHETTI: { icon: '/assets/spaghetti.webp', key: 'spaghetti', sortOrder: 505 }, // NEW
  TORTELLINI: { icon: '/assets/tortellini.webp', key: 'tortellini', sortOrder: 505 }, // NEW
  LASAGNA: { icon: '/assets/lasagneplatten.webp', key: 'lasagna', sortOrder: 505 }, // NEW
  RICE: { icon: '/assets/reis.webp', key: 'rice', sortOrder: 506 },
  NOODLES: { icon: 'mdi:noodles', key: 'noodles', sortOrder: 507 },
  FRIES: { icon: '/assets/pommes.webp', key: 'fries', sortOrder: 507 }, // NEW
  LENTILS: { icon: '/assets/linsen.webp', key: 'lentils', sortOrder: 509 }, // NEW
  CEREAL: { icon: '/assets/muesli.webp', key: 'cereal', sortOrder: 508 },

  // --- SNACKS & SWEETS (600) ---
  CHIPS: { icon: '/assets/chips.webp', key: 'chips', sortOrder: 600 },
  PRETZEL_STICKS: { icon: '/assets/salzstangen.webp', key: 'pretzel_sticks', sortOrder: 600 }, // NEW
  NUT: { icon: 'lucide:nut', key: 'nut', sortOrder: 601 },
  PEANUT: { icon: '/assets/erdnuesse.webp', key: 'peanut', sortOrder: 601 }, // NEW
  ALMOND: { icon: '/assets/mandeln.webp', key: 'almond', sortOrder: 601 }, // NEW
  WALNUT: { icon: '/assets/walnuesse.webp', key: 'walnut', sortOrder: 601 }, // NEW
  POPCORN: { icon: 'lucide:popcorn', key: 'popcorn', sortOrder: 602 },
  CHOCOLATE: { icon: '/assets/schokolade.webp', key: 'chocolate', sortOrder: 610 },
  PRALINE: { icon: '/assets/pralinen.webp', key: 'praline', sortOrder: 610 }, // NEW
  CANDY: { icon: '/assets/bonbon.webp', key: 'candy', sortOrder: 611 },
  COOKIE: { icon: 'lucide:cookie', key: 'cookie', sortOrder: 612 },
  CAKE: { icon: 'lucide:cake-slice', key: 'cake', sortOrder: 613 },
  ICE_CREAM: { icon: 'lucide:ice-cream', key: 'ice_cream', sortOrder: 614 },
  SUGAR: { icon: '/assets/zucker.webp', key: 'sugar', sortOrder: 615 },
  POWDERED_SUGAR: { icon: '/assets/puderzucker.webp', key: 'powdered_sugar', sortOrder: 615 },
  PIZZA: { icon: 'lucide:pizza', key: 'pizza', sortOrder: 620 }, // Frozen usually near ice cream? Or 620

  // --- BEVERAGES (700) ---
  DRINKS: { icon: '/assets/getränke.webp', key: 'drinks', sortOrder: 700 }, // Generic drinks
  WATER: { icon: '/assets/wasser.webp', key: 'water', sortOrder: 700 },
  JUICE: { icon: 'lucide:glass-water', key: 'juice', sortOrder: 701 },
  SODA: { icon: 'lucide:cup-soda', key: 'soda', sortOrder: 702 },
  COFFEE: { icon: '/assets/kaffee.webp', key: 'coffee', sortOrder: 703 },
  TEA: { icon: 'lucide:coffee', key: 'tea', sortOrder: 704 },
  TEA_BAGS: { icon: '/assets/teebeutel.webp', key: 'tea_bags', sortOrder: 704 },
  BEER: { icon: 'lucide:beer', key: 'beer', sortOrder: 705 },
  WINE: { icon: 'lucide:wine', key: 'wine', sortOrder: 706 },
  RED_WINE: { icon: '/assets/rotwein.webp', key: 'red_wine', sortOrder: 706 }, // NEW
  WHITE_WINE: { icon: '/assets/weisswein.webp', key: 'white_wine', sortOrder: 706 }, // NEW
  ALCOHOL: { icon: 'lucide:martini', key: 'alcohol', sortOrder: 707 },

  // --- HOUSEHOLD & HEALTH (800) ---
  TOILET_PAPER: { icon: '/assets/klopapier.webp', key: 'toilet_paper', sortOrder: 800 },
  CLEANING: { icon: 'lucide:sparkles', key: 'cleaning', sortOrder: 801 },
  NAPKINS: { icon: '/assets/servietten.webp', key: 'napkins', sortOrder: 801 }, // NEW
  TRASH: { icon: '/assets/muelltueten.webp', key: 'trash', sortOrder: 802 },
  SOAP: { icon: 'mdi:soap', key: 'soap', sortOrder: 803 },
  MEDICINE: { icon: 'lucide:pill', key: 'medicine', sortOrder: 804 },
  BABY: { icon: 'lucide:baby', key: 'baby', sortOrder: 805 },
  PET: { icon: '/assets/tierfutter.webp', key: 'pet', sortOrder: 806 },
  BATTERY: { icon: 'lucide:battery', key: 'battery', sortOrder: 807 },

  // --- OTHER (900+) ---
  FLOWER: { icon: 'lucide:flower-2', key: 'flower', sortOrder: 900 },
  GIFT: { icon: 'lucide:gift', key: 'gift', sortOrder: 901 },
  PARTY: { icon: 'lucide:party-popper', key: 'party', sortOrder: 902 },
};